import { useQuery } from '@tanstack/react-query'
import { GripVertical, Trash2 } from 'lucide-react'
import {
  useController,
  useFieldArray,
  useFormContext,
  useWatch,
} from 'react-hook-form'
import { SortableContainer, SortableElement } from 'react-sortable-hoc'

import { queryJobMasterPhaseList } from '@/services/job/query'

import { FormField } from '@/components/ui/form'
import { FormFieldset } from '@/components/ui/form-field/fieldset'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'

import { FormDto } from './helper'

export default function SchemaField() {
  const { control } = useFormContext<FormDto>()

  const { fields, append, remove, move } = useFieldArray({
    control,
    name: 'job_selection_phase',
  })

  const handleSortEnd = ({ oldIndex, newIndex }: any) => {
    move(oldIndex, newIndex)
  }

  const handleAddPhase = (phase: any) => {
    append({
      // id: Date.now(),
      phase_number: fields.length + 1,
      master_job_selection_phase_id: phase.id,
      phase: phase.phase,
      required_application_document: ['user_health', 'user_family'],
    })
  }

  return (
    <FormField
      control={control}
      name="job_selection_phase"
      render={({ field }) => {
        return (
          <FormFieldset
            label="Pilih Fase"
            noFormControl
            className="col-span-full"
          >
            <div className="w-full rounded-md border border-[#E2E8F0] p-4 md:w-1/3">
              <SortableList
                onSortEnd={handleSortEnd}
                fields={fields}
                remove={remove}
              ></SortableList>
              <div className="mt-2">
                <ListAddPhase onHandleAdd={handleAddPhase} fields={fields} />
              </div>
            </div>
          </FormFieldset>
        )
      }}
    />
  )
}

const SortableItem = SortableElement<{
  value: any
  index: any
  remove: any
  customIndex: any
}>(({ value, index, remove, customIndex }: any) => {
  const { getValues } = useFormContext<FormDto>()
  const isApplied = getValues('is_applied')

  const disableSort = isApplied

  const handleDeleteRow = () => {
    remove(customIndex)
  }

  // <div className='pr-2  cursor-pointer z-40' onClick={() => remove(index)}>
  //       <Trash2 className='w-4 text-red-400' />
  //     </div>
  return (
    <li className="group flex cursor-grab list-none flex-row justify-between gap-2 rounded-md border border-[#E2E8F0] p-2">
      <div className="flex gap-2">
        {disableSort ? <></> : <GripVertical className="w-4" />}

        {value.phase}
      </div>
      {disableSort ? (
        <></>
      ) : (
        <button onClick={handleDeleteRow} type="button">
          <Trash2 className="pointer-events-none w-4 text-red-400" />
        </button>
      )}
    </li>
  )
})
const SortableList = SortableContainer<{ fields: any; remove: any }>(
  ({ fields, remove }: any) => {
    const { getValues } = useFormContext<FormDto>()
    const isApplied = getValues('is_applied')

    const disableSort = isApplied

    return (
      <ul className="flex flex-col gap-2">
        {fields.map((value: any, index: any) => (
          <SortableItem
            value={value}
            index={index}
            remove={remove}
            key={value.id}
            customIndex={index}
            disabled={disableSort}
          />
        ))}
      </ul>
    )
  }
)

interface ListAddPhaseProps {
  onHandleAdd: (phase: any) => void
  fields: any
}
function ListAddPhase({ onHandleAdd, fields }: ListAddPhaseProps) {
  const { data, isLoading } = useQuery(queryJobMasterPhaseList())

  if (!data) {
    return <></>
  }
  const fieldIds = fields.map(
    (field: any) => field.master_job_selection_phase_id
  )
  const filteredData = data.filter((item) => !fieldIds.includes(item.id))
  return (
    <>
      <Select
        value={''}
        onValueChange={(value) => {
          const selectedPhase = data.find((p) => String(p.id) === value)
          onHandleAdd(selectedPhase)
        }}
      >
        <SelectTrigger className="h-10 border-2 border-dashed">
          <SelectValue placeholder={'+ Tambah Fase'} />
        </SelectTrigger>
        <SelectContent side="top">
          {filteredData.length == 0 ? (
            <div className="flex justify-center">Tidak ada data</div>
          ) : (
            <></>
          )}
          {filteredData?.map((p, _) => (
            <SelectItem key={_} value={String(p.id)}>
              {p.phase}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </>
  )
}
